import React from "react";
import { Navigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import IdleLogoutGuard from "./components/IdleLogoutGuard";
import { getRouteModule, hasAdminPermission } from "./utils/adminPermissions";

function ProtectedRoute({ children }) {
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const location = useLocation();

  if (!isLoggedIn) {
    return <Navigate to="/administrator" />;
  }

  const moduleKey = getRouteModule(location.pathname);
  if (!hasAdminPermission(moduleKey, "view")) {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#f8fafc", padding: "24px" }}>
        <div style={{ maxWidth: "520px", background: "#ffffff", border: "1px solid #e2e8f0", borderRadius: "18px", padding: "28px", textAlign: "center" }}>
          <h2 style={{ margin: 0, color: "#991b1b" }}>Access Denied</h2>
          <p style={{ margin: "12px 0 0", color: "#64748b", lineHeight: 1.6 }}>
            Ei page dekhar permission apnar user account-e deya nei.
          </p>
        </div>
      </div>
    );
  }

  return (
    <IdleLogoutGuard
      enabled={Boolean(isLoggedIn)}
      authKey="isLoggedIn"
      activityKey="adminLastActiveAt"
      clearKeys={["isLoggedIn", "user"]}
      redirectTo="/administrator"
    >
      {children}
    </IdleLogoutGuard>
  );
}

export default ProtectedRoute;
